/* Kennismaking plannen (sections/d-kennismaking.liquid). Praat met B&B Boeken, zaak blok-en-blaauw:
   GET  /api/salons/:slug                      modus en testzin
   GET  /api/salons/:slug/beschikbaarheid      vrije tijden per dag (?behandeling=&medewerker=&van=&tot=)
   POST /api/salons/:slug/afspraken            boeken (idempotentie per poging)
   Zonder API (instelling leeg): preview, de tijden komen uit de browser en er wordt niets geboekt.
   "Op locatie": 20 minuten met 30 minuten reistijd ervoor en erna (buffer_voor_min en buffer_na_min in de Worker, sinds
   migratie 0016). De tijd die de API geeft is de tijd dat we er zijn. Het adres gaat als velden.adres mee (verplicht). */
(function () {
  'use strict';
  var sec = document.getElementById('kennismaken');
  if (!sec || sec.dataset.init) return;
  sec.dataset.init = '1';

  var API = (sec.dataset.api || '').replace(/\/+$/, '');
  try {
    var q = new URLSearchParams(location.search).get('bb_boeken');
    if (q && /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(q)) sessionStorage.setItem('bb-boeken', q);
    var lok = sessionStorage.getItem('bb-boeken');
    if (lok && /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(lok)) API = lok;
  } catch (e) {}
  var SLUG = sec.dataset.slug;
  /* Drie standen. boeken: boeken_api ingevuld, echt boeken. preview: geen API en een niet-gepubliceerd thema, doen alsof.
     mail: geen API op het gepubliceerde thema. Dan NOOIT een nepbevestiging, maar een mail met de keuze aan info@blaauwblok.nl. */
  var ROL = (window.Shopify && Shopify.theme && Shopify.theme.role) || sec.dataset.rol || 'main';
  var STAND = API ? 'boeken' : (ROL !== 'main' ? 'preview' : 'mail');
  var PREVIEW = STAND !== 'boeken';
  window.bbPlanner = STAND;
  sec.dataset.stand = STAND;
  if (STAND === 'mail') {
    var sys = sec.querySelector('.dk-sys'); if (sys) sys.innerHTML = '<b>Kies je voorkeur.</b> Je aanvraag gaat per mail naar ons, wij bevestigen binnen 1 werkdag.';
    var go0 = document.getElementById('dkp-go'); if (go0) go0.textContent = 'Plan je kennismaking per mail';
    var nt = document.getElementById('dkp-noot'); if (nt) nt.dataset.mail = '1';
    if (window.bbProbeerHerteken) window.bbProbeerHerteken();
  }
  var VORM = {
    bellen: {n: 'Bellen', b: 'bellen', duur: 20},
    video: {n: 'Videobellen', b: 'video', duur: 20},
    locatie: {n: 'Wij komen langs', b: 'locatie', duur: 20}
  };
  var WIE = {niek: 'Niek', eline: 'Eline', '': 'Niek of Eline'};
  /* Zaakinfo uit GET /api/salons/:slug (alleen bij echt boeken). Zonder info (preview, mail): telefoon alleen verplicht bij bellen. */
  var INFO = null;
  function telVerplicht() {
    if (!st.vorm) return true;
    if (!INFO) return STAND === 'boeken' ? true : st.vorm === 'bellen';
    var b = (INFO.behandelingen || []).filter(function (x) { return x.id === VORM[st.vorm].b; })[0];
    return !(b && b.telefoon_verplicht === false);
  }
  function telUitleg() {
    var tu = document.getElementById('dkp-tel-uitleg'), t = document.getElementById('dkp-tel'); if (!tu || !t) return;
    var v = telVerplicht();
    tu.textContent = st.vorm === 'bellen' ? '(hierop bellen we je)' : v ? '(voor als er iets verandert)' : '(mag leeg)';
    t.required = v;
  }
  /* Turnstile tegen nepboekingen: alleen als de zaak een sitekey heeft (GET /api/salons/:slug, veld turnstile). Zonder sitekey
     boekt de planner zoals nu. Het widget laadt pas bij stap 4 en het token gaat mee als body.turnstile. */
  var TS = {sitekey: '', token: '', id: null,
    laad: function () {
      if (!TS.sitekey || TS.id !== null) return;
      var el = document.getElementById('dkp-ts'); if (!el) return;
      el.hidden = false;
      var teken = function () { TS.id = window.turnstile.render(el, {sitekey: TS.sitekey, action: 'afspraak', appearance: 'interaction-only', theme: 'light', language: 'nl', size: 'flexible',
        callback: function (t) { TS.token = t; }, 'expired-callback': function () { TS.token = ''; }, 'error-callback': function () { TS.token = ''; }}); };
      if (window.turnstile) return teken();
      var s = document.createElement('script'); s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; s.async = true; s.onload = teken; document.head.appendChild(s);
    },
    reset: function () { TS.token = ''; try { if (TS.id !== null) window.turnstile.reset(TS.id); } catch (e) {} }
  };
  var st = {vorm: '', wie: null, dag: '', tijd: null, dagen: [], idem: ''};
  var track = function (e, p) { try { window.ngTrack && window.ngTrack(e, p); } catch (x) {} };
  var $ = function (id) { return document.getElementById(id); };
  var box = $('dkp');
  var stappen = [].slice.call(box.querySelectorAll('[data-stap]'));
  var volgorde = ['vorm', 'wie', 'tijd', 'gegevens', 'klaar'];

  function toon(naam, focus) {
    stappen.forEach(function (s) { s.classList.toggle('on', s.dataset.stap === naam); });
    if (naam === 'gegevens') TS.laad();
    var s = box.querySelector('[data-stap="' + naam + '"]');
    if (focus !== false) {
      var f = s.querySelector('h3') || s;
      f.setAttribute('tabindex', '-1');
      f.focus({preventScroll: true});
      var r = box.getBoundingClientRect();
      if (!inPaneel() && (r.top < 0 || r.top > innerHeight * 0.6)) box.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    }
  }
  box.addEventListener('click', function (e) {
    var t = e.target.closest('[data-terug]');
    if (!t) return;
    var nu = t.closest('[data-stap]').dataset.stap;
    toon(volgorde[Math.max(0, volgorde.indexOf(nu) - 1)]);
  });

  /* ---------- Stap 1 en 2 ---------- */
  box.querySelectorAll('[data-vorm]').forEach(function (b) {
    b.addEventListener('click', function () {
      st.vorm = b.dataset.vorm;
      box.querySelectorAll('[data-vorm]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      $('dkp-adres').hidden = st.vorm !== 'locatie';
      telUitleg();
      track('KennisVorm', {content_name: st.vorm});
      toon('wie');
    });
  });
  box.querySelectorAll('[data-wie]').forEach(function (b) {
    b.addEventListener('click', function () {
      st.wie = b.dataset.wie;
      box.querySelectorAll('[data-wie]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      st.dag = ''; st.tijd = null;
      toon('tijd');
      laadTijden();
    });
  });

  /* ---------- Tijden ---------- */
  var DAG = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  var MAAND = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var MAAND_L = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  var DAG_L = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  function ymd(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function datumVan(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2], 12); }
  function plus(hhmm, min) { var p = hhmm.split(':'), t = +p[0] * 60 + +p[1] + min; return String(Math.floor(t / 60)).padStart(2, '0') + ':' + String(t % 60).padStart(2, '0'); }
  function aankomst(t) { return t.lokaal; }

  /* Preview: werkdagen 9-17, elk kwartier, niet binnen 2 uur. Een paar vaste tijden bezet, zodat het lijkt op een echte week. */
  function previewDagen() {
    var uit = [], nu = new Date(), voor = st.vorm === 'locatie' ? 30 : 0, na = st.vorm === 'locatie' ? 50 : 20;
    for (var i = 0; i < 21; i++) {
      var d = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + i, 12), wd = d.getDay();
      var dag = {datum: ymd(d), weekdag: wd, open: wd > 0 && wd < 6, tijden: []};
      if (dag.open) {
        for (var m = 9 * 60 + voor; m + na <= 17 * 60; m += 15) {
          var s = new Date(d.getFullYear(), d.getMonth(), d.getDate(), Math.floor(m / 60), m % 60);
          if (s - nu < 120 * 60000) continue;
          var h = (d.getDate() * 7 + m / 15 * 3) % 11;
          if (h < 3) continue;
          var wie = st.wie ? [st.wie] : h % 2 ? ['niek', 'eline'] : [h % 3 ? 'eline' : 'niek'];
          dag.tijden.push({start: s.toISOString(), lokaal: String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0'), wie: wie});
        }
      }
      uit.push(dag);
    }
    return uit;
  }

  var laadNr = 0;
  function laadTijden() {
    var nr = ++laadNr;
    $('dkp-dagen').innerHTML = '';
    $('dkp-tijden').innerHTML = '<p class="dkp-leeg">Vrije tijden ophalen…</p>';
    $('dkp-noot').textContent = '';
    if (PREVIEW) { st.dagen = previewDagen(); tekenDagen(); return; }
    var van = new Date(), tot = new Date(Date.now() + 27 * 86400000);
    var url = API + '/api/salons/' + SLUG + '/beschikbaarheid?behandeling=' + VORM[st.vorm].b + (st.wie ? '&medewerker=' + st.wie : '') + '&van=' + ymd(van) + '&tot=' + ymd(tot);
    fetch(url).then(function (r) { return r.json().then(function (d) { return {ok: r.ok, d: d}; }); }).then(function (x) {
      if (nr !== laadNr) return;
      if (!x.ok || !x.d.ok) throw new Error('beschikbaarheid');
      st.dagen = x.d.dagen || [];
      if (x.d.test_melding) $('dkp-test').textContent = x.d.test_melding;
      tekenDagen();
    }).catch(function () {
      if (nr !== laadNr) return;
      $('dkp-tijden').innerHTML = '';
      $('dkp-noot').innerHTML = 'Plannen lukt nu even niet. Mail ons op <a href="mailto:info@blaauwblok.nl">info@blaauwblok.nl</a>, dan spreken we een tijd af.';
    });
  }
  function tekenDagen() {
    var el = $('dkp-dagen'), werk = st.dagen.filter(function (d) { return d.weekdag > 0 && d.weekdag < 6; }).slice(0, 15);
    el.innerHTML = '';
    var eerste = '';
    werk.forEach(function (d) {
      var dt = datumVan(d.datum), b = document.createElement('button');
      b.type = 'button'; b.className = 'dkp-d'; b.dataset.dag = d.datum;
      b.innerHTML = '<span>' + DAG[dt.getDay()] + '</span><b>' + dt.getDate() + '</b><span>' + MAAND[dt.getMonth()] + '</span>';
      b.setAttribute('aria-label', DAG_L[dt.getDay()] + ' ' + dt.getDate() + ' ' + MAAND_L[dt.getMonth()] + (d.tijden.length ? '' : ', vol'));
      if (!d.tijden.length) b.disabled = true; else if (!eerste) eerste = d.datum;
      b.setAttribute('aria-pressed', 'false');
      el.appendChild(b);
    });
    if (!eerste) { $('dkp-tijden').innerHTML = '<p class="dkp-leeg">Geen vrije tijden in de komende weken. Mail ons op info@blaauwblok.nl.</p>'; return; }
    kiesDag(st.dag && werk.some(function (d) { return d.datum === st.dag && d.tijden.length; }) ? st.dag : eerste);
  }
  $('dkp-dagen').addEventListener('click', function (e) { var b = e.target.closest('[data-dag]'); if (b && !b.disabled) kiesDag(b.dataset.dag); });
  function kiesDag(datum) {
    st.dag = datum;
    $('dkp-dagen').querySelectorAll('[data-dag]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.dag === datum); });
    var d = st.dagen.find(function (x) { return x.datum === datum; }), el = $('dkp-tijden');
    el.innerHTML = '';
    (d ? d.tijden : []).forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dkp-t'; b.textContent = aankomst(t); b.dataset.start = t.start;
      b.setAttribute('aria-pressed', st.tijd && st.tijd.start === t.start ? 'true' : 'false');
      el.appendChild(b);
    });
    $('dkp-noot').textContent = (STAND === 'mail' ? 'Kies je voorkeur; we bevestigen per mail. ' : '') + (st.vorm === 'locatie' ? 'De tijd is het moment dat we bij je zijn. Het gesprek duurt 20 minuten.' : 'Het gesprek duurt 20 minuten.');
  }
  $('dkp-tijden').addEventListener('click', function (e) {
    var b = e.target.closest('[data-start]'); if (!b) return;
    var d = st.dagen.find(function (x) { return x.datum === st.dag; });
    st.tijd = d.tijden.find(function (t) { return t.start === b.dataset.start; });
    st.idem = '';
    samenvatting($('dkp-sam'));
    toon('gegevens');
    $('dkp-naam').focus({preventScroll: true});
  });
  function wieTekst() {
    if (st.wie) return WIE[st.wie];
    var w = st.tijd && st.tijd.wie;
    return w && w.length === 1 ? WIE[w[0]] : 'Niek of Eline';
  }
  function momentTekst() {
    var dt = datumVan(st.dag), a = aankomst(st.tijd);
    return DAG_L[dt.getDay()] + ' ' + dt.getDate() + ' ' + MAAND_L[dt.getMonth()] + ', ' + a + ' tot ' + plus(a, 20);
  }
  function samenvatting(el) {
    el.innerHTML = '';
    [[VORM[st.vorm].n], [momentTekst()], ['met ' + wieTekst()]].forEach(function (x) {
      var b = document.createElement('b'); b.textContent = x[0]; el.appendChild(b);
    });
  }

  /* ---------- Gegevens en boeken ---------- */
  var form = $('dkp-form');
  form.addEventListener('input', function (e) { var f = e.target.closest('.dkp-f'); var el = f && f.querySelector('.dkp-fout'); if (el && el.textContent) { el.textContent = ''; e.target.setAttribute('aria-invalid', 'false'); } });
  function fout(veld, tekst) {
    var f = form.querySelector('[data-fout="' + veld + '"]');
    if (f) f.textContent = tekst || '';
    var inp = {naam: 'dkp-naam', email: 'dkp-mail', telefoon: 'dkp-tel', straat: 'dkp-str', postcode: 'dkp-pc', plaats: 'dkp-pl'}[veld];
    if (inp) $(inp).setAttribute('aria-invalid', tekst ? 'true' : 'false');
  }
  function inRegio(pc) {
    var m = /^\s*(\d{4})\s*([a-z]{2})\s*$/i.exec(pc || '');
    if (!m) return null;
    var n = +m[1];
    return (n >= 7700 && n <= 7999) || (n >= 9500 && n <= 9599);
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
  }
  function controleer() {
    ['naam', 'email', 'telefoon', 'straat', 'postcode', 'plaats', 'akkoord', 'algemeen'].forEach(function (v) { fout(v, ''); });
    var ok = true;
    var naam = $('dkp-naam').value.trim(), mail = $('dkp-mail').value.trim(), tel = $('dkp-tel').value.trim();
    if (naam.length < 2) { fout('naam', 'Vul je naam in.'); ok = false; }
    if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(mail)) { fout('email', 'Vul een geldig e-mailadres in.'); ok = false; }
    if ((telVerplicht() || tel) && tel.replace(/\D/g, '').length < 9) { fout('telefoon', 'Vul een geldig nummer in, bijvoorbeeld 06 12345678.'); ok = false; }
    if (st.vorm === 'locatie') {
      if ($('dkp-str').value.trim().length < 4 || !/\d/.test($('dkp-str').value)) { fout('straat', 'Vul straat en huisnummer in.'); ok = false; }
      var r = inRegio($('dkp-pc').value);
      if (r === null) { fout('postcode', 'Bijvoorbeeld 7891 AB.'); ok = false; }
      else if (!r) { fout('postcode', 'Op locatie komen we in de regio Emmen en Zuidoost-Drenthe. Kies anders bellen of videobellen.'); ok = false; }
      if ($('dkp-pl').value.trim().length < 2) { fout('plaats', 'Vul de plaats in.'); ok = false; }
    }
    if (TS.sitekey && !TS.token) { fout('algemeen', 'De controle tegen spam is nog bezig. Probeer het zo opnieuw.'); ok = false; }
    if (!ok) { var eerste = form.querySelector('[aria-invalid="true"]'); if (eerste) eerste.focus(); }
    return ok;
  }
  function opmerking() {
    var L = ['Kennismaking: ' + VORM[st.vorm].n];
    var zaak = $('dkp-zaak').value.trim(), over = $('dkp-over').value.trim();
    if (zaak) L.push('Bedrijf: ' + zaak);
    if (over) L.push('Onderwerp: ' + over);
    return L.join('\n').slice(0, 500);
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!st.tijd || !controleer()) return;
    var go = $('dkp-go');
    go.disabled = true; go.textContent = 'Bezig met plannen…';
    if (!st.idem) st.idem = uuid();
    var body = {
      behandeling: VORM[st.vorm].b, start: st.tijd.start, medewerker: st.wie || null,
      naam: $('dkp-naam').value.trim(), email: $('dkp-mail').value.trim(), telefoon: $('dkp-tel').value.trim(),
      opmerking: opmerking(), website: $('dkp-w').value, idempotentie: st.idem
    };
    /* Het akkoord alleen als de zaak het nog vraagt; anders staan de huisregels en de privacyregel als tekst bij het formulier */
    if (!(INFO && INFO.akkoord_vereist === false)) body.akkoord = true;
    if (!body.telefoon) delete body.telefoon;
    if (TS.token) body.turnstile = TS.token;
    if (st.vorm === 'locatie') body.velden = {adres: ($('dkp-str').value.trim() + ', ' + $('dkp-pc').value.trim().toUpperCase() + ' ' + $('dkp-pl').value.trim()).slice(0, 200)};
    var klaar = function () { go.disabled = false; go.textContent = STAND === 'mail' ? 'Plan je kennismaking per mail' : 'Plan de kennismaking'; };
    if (STAND === 'mail') { klaar(); perMail(body); return; }
    if (PREVIEW) {
      setTimeout(function () { klaar(); bevestig({email: body.email, preview: true}); }, 500);
      return;
    }
    fetch(API + '/api/salons/' + SLUG + '/afspraken', {method: 'POST', headers: {'content-type': 'application/json'}, body: JSON.stringify(body)})
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return {s: r.status, d: d}; }); })
      .then(function (x) {
        klaar();
        if (x.s === 201 || (x.s === 200 && x.d.ok)) { bevestig(x.d); return; }
        if (x.s === 409 || (x.d && x.d.fout === 'tijd_ongeldig')) {
          st.tijd = null; st.idem = '';
          toon('tijd'); laadTijden();
          setTimeout(function () { $('dkp-noot').textContent = 'Die tijd is net vergeven. Kies een andere.'; }, 400);
          return;
        }
        if (x.s === 422 && x.d.fouten) {
          Object.keys(x.d.fouten).forEach(function (k) { var v = x.d.fouten[k]; if (k === 'velden' && v && typeof v === 'object') { fout('straat', v.adres || 'Vul je adres in.'); return; } fout(k in {naam: 1, email: 1, telefoon: 1, akkoord: 1} ? k : 'algemeen', typeof v === 'string' ? v : 'Controleer dit veld.'); });
          return;
        }
        st.idem = x.s >= 500 ? st.idem : '';
        fout('algemeen', (x.d && (x.d.melding || x.d.tekst)) || 'Plannen lukt nu even niet. Probeer het opnieuw, of mail ons op info@blaauwblok.nl.');
      })
      .then(function () { TS.reset(); })
      .catch(function () { klaar(); TS.reset(); fout('algemeen', 'Geen verbinding. Probeer het opnieuw; je kennismaking komt er nooit dubbel in.'); });
  });
  /* Mailstand: open de eigen mailapp met de keuze erin. Er wordt niets opgeslagen en niets geboekt. */
  function perMail(b) {
    var L = ['Ik wil graag een kennismaking plannen.', '', 'Hoe: ' + VORM[st.vorm].n, 'Met: ' + wieTekst(), 'Voorkeur: ' + momentTekst(), '',
      'Naam: ' + b.naam, 'Telefoon: ' + (b.telefoon || 'niet opgegeven')];
    var zaak = $('dkp-zaak').value.trim(), over = $('dkp-over').value.trim();
    if (zaak) L.push('Bedrijf: ' + zaak);
    if (b.velden && b.velden.adres) L.push('Adres: ' + b.velden.adres);
    if (over) L.push('', 'Waar ik het over wil hebben: ' + over);
    var url = 'mailto:info@blaauwblok.nl?subject=' + encodeURIComponent('Kennismaking: ' + VORM[st.vorm].n.toLowerCase() + ', ' + momentTekst()) + '&body=' + encodeURIComponent(L.join('\n'));
    samenvatting($('dkp-ok-sam'));
    $('dkp-ok-h').textContent = 'Bijna klaar.';
    var p = $('dkp-ok-p'); p.textContent = 'Je mailprogramma opent met je aanvraag. Verstuur de mail, dan bevestigen we je kennismaking binnen 1 werkdag. Opent er niets? ';
    var a = document.createElement('a'); a.href = url; a.textContent = 'Open de mail opnieuw'; p.appendChild(a);
    p.appendChild(document.createTextNode(' of mail naar info@blaauwblok.nl.'));
    toon('klaar');
    track('KennisPerMail', {content_name: st.vorm});
    st.mailUrl = url; sec.dataset.mail = url.slice(0, 2000);   /* voor de test: de mail die we openen */
    location.href = url;
  }
  function bevestig(d) {
    samenvatting($('dkp-ok-sam'));
    var p = $('dkp-ok-p');
    p.textContent = '';
    if (d.preview) {
      $('dkp-ok-h').textContent = 'Zo ziet het eruit.';
      p.textContent = 'Dit is de preview van de nieuwe site: er is niets geboekt en er gaat geen mail uit.';
    } else {
      $('dkp-ok-h').textContent = 'Staat erin.';
      p.appendChild(document.createTextNode('Je krijgt een bevestiging op ' + (d.email || 'je e-mailadres') + '. '));
      var w = st.vorm === 'bellen' ? 'We bellen je op het afgesproken moment.' : st.vorm === 'video' ? 'De link voor het videogesprek sturen we je per mail.' : 'We zijn er op de tijd hierboven.';
      p.appendChild(document.createTextNode(w + ' '));
      var l = d.afspraak && d.afspraak.links;
      if (l && l.agenda) { var a = document.createElement('a'); a.href = l.agenda; a.textContent = 'Zet in je agenda'; p.appendChild(a); p.appendChild(document.createTextNode(' · ')); }
      if (l && l.beheer) { var b = document.createElement('a'); b.href = l.beheer; b.textContent = 'Afzeggen'; p.appendChild(b); }
      p.appendChild(document.createTextNode(' Tot dan, Niek & Eline.'));
      if (d.test_melding) { var t = document.createElement('small'); t.style.display = 'block'; t.style.marginTop = '10px'; t.textContent = d.test_melding; p.appendChild(t); }
    }
    toon('klaar');
    track('KennisGepland', {content_name: st.vorm, content_category: st.wie || 'geen voorkeur'});
  }

  /* ---------- Boek-paneel: de planner opent op de plek waar je bent (popover, bb-css-lab 06) ---------- */
  var paneel = null, plek = document.createComment('planner'), terugNaar = null;
  if (typeof HTMLElement !== 'undefined' && HTMLElement.prototype.showPopover) {
    paneel = document.createElement('div');
    paneel.id = 'dk-paneel'; paneel.className = 'dk-paneel'; paneel.setAttribute('popover', 'auto');
    paneel.setAttribute('role', 'dialog'); paneel.setAttribute('aria-labelledby', 'dk-paneel-h');
    paneel.innerHTML = '<div class="dk-pk"><p id="dk-paneel-h">Plan je kennismaking<small>20 minuten, gratis. Je spreekt Niek of Eline.</small></p><button type="button" class="dk-px" aria-label="Sluiten"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/></svg></button></div>';
    document.body.appendChild(paneel);
    paneel.querySelector('.dk-px').addEventListener('click', function () { paneel.hidePopover(); });
    paneel.addEventListener('toggle', function (ev) {
      if (ev.newState !== 'closed' || !plek.parentNode) return;
      plek.parentNode.insertBefore(box, plek); plek.remove();
      if (terugNaar && terugNaar.focus) terugNaar.focus({preventScroll: true});
    });
  }
  function inPaneel() { return !!(paneel && paneel.contains(box)); }
  function openPaneel(knop) {
    terugNaar = knop;
    box.parentNode.insertBefore(plek, box);
    paneel.appendChild(box);
    /* lazy beelden in de top layer laden niet altijd vanzelf */
    box.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    paneel.showPopover();
    var eerst = box.querySelector('.dkp-stap.on button:not([data-terug]), .dkp-stap.on input');
    setTimeout(function () { if (eerst) eerst.focus({preventScroll: true}); }, 60);
    track('KennisPaneel', {content_name: location.pathname});
  }
  /* ---------- Elke "Plan een gesprek" op de home opent de planner ---------- */
  function naarPlanner(e) {
    if (e) e.preventDefault();
    var knop = e && e.target && e.target.closest ? e.target.closest('a,button') : null;
    var r = sec.getBoundingClientRect(), inBeeld = r.top < innerHeight * .4 && r.bottom > innerHeight * .6;
    if (paneel && knop && !inBeeld && !box.contains(knop)) { if (!inPaneel()) openPaneel(knop); return; }
    sec.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    var eerst = box.querySelector('.dkp-stap.on button:not([data-terug]), .dkp-stap.on input');
    setTimeout(function () { if (eerst) eerst.focus({preventScroll: true}); }, 450);
    track('KennisOpen', {content_name: location.pathname});
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href');
    if (a.hasAttribute('data-kennis') || ((/#contact$/.test(h) || /#kennismaken$/.test(h)) && a.pathname === location.pathname)) naarPlanner(e);
  });
  /* Uit de calculator of een dienstpagina (?wens=): vul het onderwerp alvast in. Het contactformulier bestaat niet meer. */
  (function () {
    var over = $('dkp-over'), tekst = '';
    try {
      var c = JSON.parse(sessionStorage.getItem('bb-calc') || 'null');
      if (c && c.t && Date.now() - c.t < 3600000 && c.link) tekst = 'Ik heb de prijscalculator ingevuld: ' + c.link;
    } catch (x) {}
    var w = new URLSearchParams(location.search).get('wens');
    if (!tekst && w) tekst = 'Ik heb interesse in: ' + w.replace(/[<>]/g, '').slice(0, 60);
    if (tekst && over && !over.value) over.value = tekst.slice(0, 300);
  })();
  if (/^#(contact|kennismaken)$/.test(location.hash)) setTimeout(naarPlanner, 300);
  /* "Dit wil ik ook" (data-wens): vul het onderwerp in en open de planner, zonder de pagina te herladen */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-wens]');
    if (!a) return;
    var over = $('dkp-over');
    if (over) over.value = ('Ik heb interesse in: ' + a.getAttribute('data-wens')).slice(0, 300);
    track('DitWilIkOok', {content_name: a.getAttribute('data-wens')});
    naarPlanner(e);
  });
  /* De sitekey voor Turnstile, alleen als we echt boeken */
  /* Zaakinfo van B&B Boeken: Turnstile-sitekey, of het akkoord nodig is, telefoon per behandeling en de privacylink */
  if (STAND === 'boeken') fetch(API + '/api/salons/' + SLUG).then(function (r) { return r.ok ? r.json() : null; }).then(function (x) {
    /* het antwoord is {ok, salon: {...}} */
    var d = x && (x.salon || x); if (!d) return; INFO = d;
    if (typeof d.turnstile === 'string' && d.turnstile) { TS.sitekey = d.turnstile; var g = box.querySelector('[data-stap="gegevens"]'); if (g && g.classList.contains('on')) TS.laad(); }
    if (typeof d.privacy_url === 'string' && /^https:\/\//.test(d.privacy_url)) { var pl = form.querySelector('.dkp-regels a'); if (pl) pl.href = d.privacy_url; }
    telUitleg();
  }).catch(function () {});
})();
